let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ehLR6")).then(() => parcelRequire('1KMTF'));